const videoSource20 = [
  {
    id: "video16",
    src: require("./3_5.mp4"),
  },
  {
    id: "video17",
    src: require("./3_6.mp4"),
  },
  {
    id: "video18",
    src: require("./3_7.mp4"),
  },
];

export default videoSource20;
